// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z-index-1{z-index:1}
`, "",{"version":3,"sources":["webpack://./src/processes/massive_actions/CensusCooler/pages/NewCensusProcess/styles.scss"],"names":[],"mappings":"AAEA,WACE,SAAU","sourcesContent":["@import \"src/styles/global/variables\";\n\n.z-index-1 {\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
